import { Controller } from "@hotwired/stimulus"

// Manages the Pause Membership modal with selectable cards:
// - indefinite: resume date hidden, always valid
// - auto_resume/create_task: resume date shown, required for valid
// Pause start date (optional): blank pauses immediately; a future date schedules
// the pause and must fall before the resume date.
// Fee section: when checkbox checked, amount required.
export default class extends Controller {
  static targets = ["modeRadio", "startInput", "dateSection", "dateInput", "dateError", "feeCheckbox", "feeAmountSection", "feeAmountInput", "submitBtn"]

  connect() {
    this.toggle()
    this.toggleFeeSection()
    this.validate()
  }

  toggle() {
    const mode = this.selectedMode
    const showDate = mode === "auto_resume" || mode === "create_task"
    if (this.hasDateSectionTarget) {
      this.dateSectionTarget.classList.toggle("hidden", !showDate)
    }
    if (this.hasDateInputTarget) {
      this.dateInputTarget.disabled = !showDate
      if (showDate && !this.dateInputTarget.value) {
        const min = this.dateInputTarget.min
        if (min) this.dateInputTarget.value = min
      } else if (!showDate) {
        this.dateInputTarget.value = ""
      }
    }
    this.validate()
  }

  toggleFeeSection() {
    const chargeFee = this.hasFeeCheckboxTarget && this.feeCheckboxTarget.checked
    if (this.hasFeeAmountSectionTarget) {
      this.feeAmountSectionTarget.classList.toggle("hidden", !chargeFee)
    }
    this.validate()
  }

  validate() {
    if (!this.hasSubmitBtnTarget) return
    const mode = this.selectedMode
    let valid = true
    let dateMessage = ""

    if (mode === "auto_resume" || mode === "create_task") {
      const resume = this.hasDateInputTarget ? this.dateInputTarget.value : ""
      if (!resume) {
        valid = false
      } else if (this.startValue && resume <= this.startValue) {
        // The pause start date must come before the resume date.
        valid = false
        dateMessage = "Resume date must be after the pause start date."
      }
    }

    if (this.hasFeeCheckboxTarget && this.feeCheckboxTarget.checked) {
      const amount = this.hasFeeAmountInputTarget ? parseFloat(String(this.feeAmountInputTarget.value).replace(/[^0-9.]/g, "")) : 0
      valid = valid && !isNaN(amount) && amount > 0
    }

    if (this.hasDateErrorTarget) {
      this.dateErrorTarget.textContent = dateMessage
      this.dateErrorTarget.classList.toggle("hidden", !dateMessage)
    }

    this.submitBtnTarget.disabled = !valid
  }

  get startValue() {
    return this.hasStartInputTarget ? this.startInputTarget.value : ""
  }

  get selectedMode() {
    if (!this.hasModeRadioTarget) return "indefinite"
    const checked = this.modeRadioTargets.find((el) => el.checked)
    return checked ? checked.value : "indefinite"
  }
}
